import styled from 'styled-components';

import { List } from '@zillow/constellation';

export const StyledListItem = styled(List.Item)`
    && {
        padding: 0;
    }
`;
